import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Fail fast: a missing config would silently make every query 401.
  // We log instead of throw so the auth-less player route can still mount
  // a friendly error screen.
  console.error(
    '[signage] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. ' +
      'See .env.example.',
  );
}

export const supabase: SupabaseClient = createClient(url ?? '', anonKey ?? '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export const STORAGE_BUCKET = 'signage-media';
